import { RouteObject } from "react-router-dom";
import RouteProtector from "./RouteProtector";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";

const CreateAssignment = lazyWithReload(
  () =>
    import("src/supervisoryTeam/features/CreateAssignment/CreateAssignment"),
);

const AssigneeHistory = lazyWithReload(
  () => import("src/supervisoryTeam/features/AssigneeHistory/AssigneeHistory"),
);

const AssignerHistory = lazyWithReload(
  () => import("src/supervisoryTeam/features/AssignerHistory/AssignerHistory"),
);

export const supervisoryTeamPaths: RouteObject = {
  path: "/supervisoryTeam",
  children: [
    {
      path: "createAssignment",
      element: (
        <RouteProtector allowedUsers={["isSupervisorAssigner"]}>
          <CreateAssignment />
        </RouteProtector>
      ),
    },
    {
      path: "assigneeHistory",
      element: (
        <RouteProtector allowedUsers={["isSupervisorAssignee"]}>
          <AssigneeHistory />
        </RouteProtector>
      ),
    },
    {
      path: "assignerHistory",
      element: (
        <RouteProtector allowedUsers={["isSupervisorAssigner"]}>
          <AssignerHistory />
        </RouteProtector>
      ),
    },
  ],
};
